export enum KpiSETypes {
  'LOAD_REQUEST' = '@kpiSE/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@kpiSE/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@kpiSE/LOAD_FAILURE',
}

export interface IPoint {
  time: string;
  value: number;
}

export interface IKpi {
  card: string;
  data: IPoint[];
  protocolos: number[];
  qtd: number;
  total: number;
  percentual: number;
}

export interface KpiSEState {
  readonly data: IKpi[];
  readonly error: boolean;
  readonly loading: boolean;
}
